import React from "react"

import { Link } from "gatsby"
import AniLink from "gatsby-plugin-transition-link/AniLink"

const Footer = ({ toggleModalVisibility }) => {
  return (
    <footer>
      <div className="container">
        <div
          className="footer-block contact-footer-block"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img
            src="/images/control-gap-full-logo-white.svg"
            alt="control-gap"
            style={{ width: 250, maxWidth: "90%" }}
          />
          <a
            href="https://www.linkedin.com/company/control-gap-inc-?originalSubdomain=ca"
            style={{ width: "40px", marginTop: "2px" }}
            className=" linkedin"
          >
            <i className="control-gap">x</i>
          </a>
        </div>
        <div className="footer-block">
          <Link to="/#services">Services</Link>
          <AniLink to="/services/cybersecurity">Cybersecurity</AniLink>
          <AniLink fade to="/services/offensive-security">
            Offensive Security
          </AniLink>
          <AniLink fade to="/services/pci-compliance">
            PCI Compliance
          </AniLink>
          <AniLink fade to="/services/data-remediation">
            Data Remediation
          </AniLink>
        </div>
        <div className="footer-block">
          <AniLink fade to="/about-us">
            About
          </AniLink>
          <AniLink fade to="/about-us">
            About Us
          </AniLink>
          <Link to="/about-us#team">Our Team</Link>
          <Link to="/about-us#credentials">Our Credentials</Link>
        </div>
        <div className="footer-block">
          <AniLink fade to="/careers">
            Careers
          </AniLink>
          <Link to="/careers#join">Join Our Team</Link>
        </div>
        <div className="footer-block">
          <AniLink fade to="/blog">
            Blog
          </AniLink>
          <a href="/blog">All Posts</a>
          <a href="/blog?tag=blog">Blog Posts</a>
          <a href="/blog?tag=insecurity">Weekly [in]security</a>
          <a href="/blog?tag=events">Events</a>
          <a href="/index-pci-frequently-asked-questions/">PCI-FAQs</a>
        </div>
        <div className="footer-block contact-footer-block">
          <button
            onClick={toggleModalVisibility}
            onKeyDown={toggleModalVisibility}
          >
            <span>CONTACT</span>
          </button>
          <a href="mailto:info@controlgap.com">info@controlgap.com</a>
          <a href="tel:1-866-644-8808">1.866.644.8808</a>{" "}
        </div>
      </div>
      <div className="container terms">
        <p>© Control Gap Inc. All Rights Reserved.</p>

        <AniLink fade to="/terms">
          Terms of Use
        </AniLink>
        <AniLink fade to="/privacypolicy">
          Privacy Policy
        </AniLink>
      </div>
    </footer>
  )
}
export default Footer
